import BaseResource                        from '@/lib/data/resource/BaseResource'
import { collect }                         from '@/lib/utils/array'

import NIIAssetNameResource                   from '@/api/resources/asset/NIIAssetNameResource'
import NIIHistoricalSpectrumAssetResource from '@/api/resources/risks/NIIHistoricalSpectrumAssetResource'

export default class NIIHistoricalSpectrumResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    const selectedPeriod = payload?.selectedPeriod ?? 'risk12mAnalysisData'

    const o = payload[selectedPeriod]?.historicalExposure || null

    this.Assets = collect(o?.components || [], NIIAssetNameResource)
    this.Data = collect(o?.data || [], NIIHistoricalSpectrumAssetResource)
    this.Dates = o?.dates || []
  }

  /* PROPERTIES */

  /* METHODS */
}
